import { createSlice } from '@reduxjs/toolkit';

const productsSlice = createSlice({
	name: 'products',
	initialState: {
		loadingProducts: false,
		filters: {
			name: '',
			index: 1,
			code: '',
			stock: '',
			supplier: '',
			searchtext: '',
			// sortBy: 'price_lh',
			brandCode: '',
			attrvalues: '',
			m1catsString: '',
			m2catsString: '',
			m3catsString: '',
			m4catsString: '',
			m5catsString: '',
			m6catsString: '',
			m6catsString: '',
			pricefrom: '',
			priceto: '',
			showitems: 20,
			promotion: 'no',
			total: '',
			totalpages: '',
			currentpage: 1,
			ourStock: 0,
			supplierStock: 0,
			outofStock: 0,
			stockout: '',
			maxprice: 1,
			link: null,
			singleattribute: '',
			singlebrand: '',
			sortby: 'price_lh',
			minorcats: '',
		},
		error: null,
		productDetails: null,
		loadingproductDetails: false,
		totalLoading: false,
		productsLoading: false,
	},
	reducers: {
		getProducts(state, action) {
			return { ...state, loadingProducts: true, productsLoading: true };
		},
		setProducts(state, action) {
			const { filters, ...productsData } = action.payload;
			let loadingProducts = true;

			// if (state.totalLoading == false || state.productsLoading == false) {
			// 	loadingProducts = false;
			// }
			if (
				state.productsLoading == false ||
				productsData.productsLoading == false
			) {
				loadingProducts = false;
			}

			return {
				...state,
				filters: { ...state.filters, ...filters },
				loadingProducts: loadingProducts,
				error: null,
				...productsData,
			};
		},
		getTotalProducts(state, action) {
			return { ...state, totalLoading: true };
		},
		getProductsFail(state, action) {
			const error = action.payload;
			return { ...state, error: { ...error }, loadingProducts: false };
		},
		setFilters(state, action) {
			const filters = { ...state.filters, ...action.payload };
			return {
				...state,
				filters: { ...state.filters, ...filters },
			};
		},
		getProduct(state, action) {
			return { ...state, loadingproductDetails: true };
		},
		setProduct(state, action) {
			const { product } = action.payload;
			return {
				...state,
				loadingproductDetails: false,
				error: null,
				productDetails: product,
			};
		},
	},
});

export const {
	getProducts,
	setProducts,
	getProductsFail,
	setFilters,
	getProduct,
	setProduct,
	getTotalProducts,
} = productsSlice.actions;

export default productsSlice.reducer;
